<template>
  <div class="page">
    <!-- 统一风格页头 -->
    <div class="page-header">
      <div class="header-left">
        <h1 class="page-title">學生激活統計</h1>
        <p class="page-subtitle">按分校查看各年級學生激活數量統計</p>
      </div>
      <div class="header-right">
        <!-- 可扩展添加导出/刷新等按钮 -->
      </div>
    </div>

    <div class="layout">
      <!-- 搜索筛选区 -->
      <div class="search-card">
        <div class="search-row">
          <div class="search-item">
            <!-- 移除了 search-text 标签 -->
            <el-select
                size="small"
                @change="getGradeStudentCountByBranch"
                v-model="formLabelAlign.branchSchoolId"
                placeholder="請選擇分校"
                filterable
                ref="branchSchoolSelect"
                :filter-method="filterBranchSchool"
                clearable
                style="width: 100%;"
            >
              <el-option
                  v-for="(item) in filteredBranchSchools"
                  :key="item.id"
                  :label="`${item.abbreviation || ''}${item.nameZh || ''}`"
                  :value="item.id"
                  :title="`${item.abbreviation || ''}${item.nameZh || ''}`"
              ></el-option>
            </el-select>
          </div>
          <div class="search-buttons">
            <el-button size="small" type="warning" @click="getGradeStudentCountByBranch" icon="el-icon-search">
              搜尋
            </el-button>
            <el-button size="small" @click="resetSearch" icon="el-icon-refresh">
              重置
            </el-button>
          </div>
        </div>
      </div>

      <!-- 数据展示区 -->
      <div class="data-container">
        <!-- PC端表格（≥768px显示） -->
        <div class="pc-table">
          <el-table
              :data="tableData"
              style="width: 100%;"
              show-summary
              :summary-method="getTableSummary"
              border
              stripe
              size="small"
              :empty-text="tableData.length === 0 ? '暫無學生激活數據' : ''"
          >
            <el-table-column label="#" type="index" width="60"></el-table-column>
            <el-table-column prop="abbreviation" label="分校" align="center" min-width="100">
              <template slot-scope="{ row }">
                <span class="branch-name">{{ row.abbreviation || '-' }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="p1" label="P1" align="center" width="80">
              <template slot-scope="{ row }">
                <span>{{ row.p1 }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="p2" label="P2" align="center" width="80">
              <template slot-scope="{ row }">
                <span>{{ row.p2 }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="p3" label="P3" align="center" width="80">
              <template slot-scope="{ row }">
                <span>{{ row.p3 }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="p4" label="P4" align="center" width="80">
              <template slot-scope="{ row }">
                <span>{{ row.p4 }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="p5" label="P5" align="center" width="80">
              <template slot-scope="{ row }">
                <span>{{ row.p5 }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="p6" label="P6" align="center" width="80">
              <template slot-scope="{ row }">
                <span>{{ row.p6 }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="totalCount" label="總計" align="center" width="100">
              <template slot-scope="{ row }">
                <span class="total-count">{{ row.totalCount }}</span>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <!-- 手机端卡片列表（<768px显示） -->
        <div class="mobile-cards">
          <div class="branch-card" v-for="(row, index) in tableData" :key="index">
            <!-- 卡片头部 -->
            <div class="card-header">
              <div class="branch-title">{{ row.abbreviation || '未知分校' }}</div>
              <div class="branch-total">總計：<span class="total-num">{{ row.totalCount }}</span></div>
            </div>

            <!-- 年级数据 -->
            <div class="grade-grid">
              <div class="grade-item">
                <div class="grade-label">P1</div>
                <div class="grade-value">{{ row.p1 }}</div>
              </div>
              <div class="grade-item">
                <div class="grade-label">P2</div>
                <div class="grade-value">{{ row.p2 }}</div>
              </div>
              <div class="grade-item">
                <div class="grade-label">P3</div>
                <div class="grade-value">{{ row.p3 }}</div>
              </div>
              <div class="grade-item">
                <div class="grade-label">P4</div>
                <div class="grade-value">{{ row.p4 }}</div>
              </div>
              <div class="grade-item">
                <div class="grade-label">P5</div>
                <div class="grade-value">{{ row.p5 }}</div>
              </div>
              <div class="grade-item">
                <div class="grade-label">P6</div>
                <div class="grade-value">{{ row.p6 }}</div>
              </div>
            </div>
          </div>

          <!-- 移动端总计卡片 -->
          <div class="total-card" v-if="tableData.length > 0">
            <div class="total-header">整體統計</div>
            <div class="total-grid">
              <div class="total-grade-item">
                <div class="grade-label">P1</div>
                <div class="grade-value">{{ summaryData.p1 }}</div>
              </div>
              <div class="total-grade-item">
                <div class="grade-label">P2</div>
                <div class="grade-value">{{ summaryData.p2 }}</div>
              </div>
              <div class="total-grade-item">
                <div class="grade-label">P3</div>
                <div class="grade-value">{{ summaryData.p3 }}</div>
              </div>
              <div class="total-grade-item">
                <div class="grade-label">P4</div>
                <div class="grade-value">{{ summaryData.p4 }}</div>
              </div>
              <div class="total-grade-item">
                <div class="grade-label">P5</div>
                <div class="grade-value">{{ summaryData.p5 }}</div>
              </div>
              <div class="total-grade-item">
                <div class="grade-label">P6</div>
                <div class="grade-value">{{ summaryData.p6 }}</div>
              </div>
              <div class="total-all-item">
                <div class="grade-label">總計</div>
                <div class="grade-value total-all">{{ summaryData.totalAll }}</div>
              </div>
            </div>
          </div>

          <!-- 空数据提示 -->
          <div class="empty-tip" v-if="tableData.length === 0">
            <i class="el-icon-data-empty"></i>
            <p>暫無學生激活數據</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getGradeStudentCountByBranch } from "@/api/setting";

export default {
  data() {
    return {
      formLabelAlign: {
        branchSchoolId: null
      },
      filteredBranchSchools: [],
      tableData: [],
      summaryData: {
        p1: 0,
        p2: 0,
        p3: 0,
        p4: 0,
        p5: 0,
        p6: 0,
        totalAll: 0
      }
    };
  },
  created() {
    this.getGradeStudentCountByBranch();
    // 初始化时加载全部校区列表
    this.filteredBranchSchools = this.$store.getters.branchSchools || [];
  },
  methods: {
    // 重置搜索条件
    resetSearch() {
      this.formLabelAlign.branchSchoolId = null;
      // 重置筛选列表
      this.filteredBranchSchools = this.$store.getters.branchSchools || [];
      this.getGradeStudentCountByBranch();
    },
    // 自定义筛选方法：根据输入关键词匹配校区缩写
    filterBranchSchool(val) {
      // 1. 兜底获取分校列表，避免 null/undefined
      const branchSchools = this.$store.getters.branchSchools || [];

      if (!val) {
        // 输入为空时显示全部
        this.filteredBranchSchools = branchSchools;
      } else {
        // 2. 统一转小写+去除首尾空格，保证匹配一致性
        const searchText = val.toLowerCase().trim();

        // 3. 同时匹配 abbreviation 和 nameZh（都做空值兜底）
        this.filteredBranchSchools = branchSchools.filter(item => {
          // 空值兜底：避免 item.abbreviation/nameZh 为 null/undefined 时报错
          const abbreviation = (item.abbreviation || '').toLowerCase();
          const nameZh = (item.nameZh || '').toLowerCase();
          const nameEn = (item.nameEn || '').toLowerCase();
          // 满足任意一个字段匹配即可
          return abbreviation.includes(searchText) || nameZh.includes(searchText) || nameEn.includes(searchText);
        });
      }
    },
    // 获取数据并强制转换数值类型
    getGradeStudentCountByBranch() {
      getGradeStudentCountByBranch(this.formLabelAlign).then((v) => {
        // 核心修复1：转换所有数值字段为数字，避免字符串/undefined导致累加错误
        this.tableData = (v.data || []).map(row => ({
          ...row,
          p1: Number(row.p1) || 0,
          p2: Number(row.p2) || 0,
          p3: Number(row.p3) || 0,
          p4: Number(row.p4) || 0,
          p5: Number(row.p5) || 0,
          p6: Number(row.p6) || 0,
          totalCount: Number(row.totalCount) || 0
        }));

        // 更新汇总数据（供移动端使用）
        this.calculateSummary();
      }).catch(err => {
        console.error('获取数据失败：', err);
        this.tableData = [];
        this.calculateSummary();
      });
    },
    // 计算汇总数据（供移动端使用）
    calculateSummary() {
      let totalP1 = 0, totalP2 = 0, totalP3 = 0, totalP4 = 0, totalP5 = 0, totalP6 = 0, totalAll = 0;

      this.tableData.forEach(row => {
        totalP1 += Number(row.p1) || 0;
        totalP2 += Number(row.p2) || 0;
        totalP3 += Number(row.p3) || 0;
        totalP4 += Number(row.p4) || 0;
        totalP5 += Number(row.p5) || 0;
        totalP6 += Number(row.p6) || 0;
        totalAll += Number(row.totalCount) || 0;
      });

      this.summaryData = {
        p1: totalP1,
        p2: totalP2,
        p3: totalP3,
        p4: totalP4,
        p5: totalP5,
        p6: totalP6,
        totalAll: totalAll
      };
    },
    // 核心修复2：汇总方法返回纯值数组（Element UI 标准格式）
    getTableSummary({ data }) {
      // 初始化总计值
      let totalP1 = 0, totalP2 = 0, totalP3 = 0, totalP4 = 0, totalP5 = 0, totalP6 = 0, totalAll = 0;

      // 累加数据（双重容错）
      data.forEach(row => {
        totalP1 += Number(row.p1) || 0;
        totalP2 += Number(row.p2) || 0;
        totalP3 += Number(row.p3) || 0;
        totalP4 += Number(row.p4) || 0;
        totalP5 += Number(row.p5) || 0;
        totalP6 += Number(row.p6) || 0;
        totalAll += Number(row.totalCount) || 0;
      });

      // 返回纯值数组（必须和表格列数一一对应）
      return [
        '總計',        // 第1列：序号列
        '全部',        // 第2列：分校列
        totalP1,       // 第3列：P1
        totalP2,       // 第4列：P2
        totalP3,       // 第5列：P3
        totalP4,       // 第6列：P4
        totalP5,       // 第7列：P5
        totalP6,       // 第8列：P6
        totalAll       // 第9列：總計
      ];
    }
  },
};
</script>

<style lang="scss" scoped>
/* 基础样式 */
.page {
  padding: 16px;
  background: #f5f7fa;
  min-height: calc(100vh - 60px);
}

/* 统一风格页头 */
.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0px;
  padding-bottom: 16px;
  border-bottom: 1px solid #e4e7ed;

  .header-left {
    .page-title {
      font-size: 22px;
      font-weight: 600;
      color: #B62D2E;
      margin: 0 0 4px 0;
    }
    .page-subtitle {
      font-size: 14px;
      color: #6c757d;
      margin: 0;
    }
  }

  .header-right {
    display: flex;
    gap: 8px;
  }
}

/* 布局容器 */
.layout {
  background: #fff;
  border-radius: 8px;
  //padding: 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

/* 搜索卡片样式 */
.search-card {
  background: #f8f9fa;
  padding: 16px;
  border-radius: 6px;
  margin-bottom: 20px;

  .search-row {
    display: flex;
    gap: 12px;
    flex-wrap: wrap;
    align-items: center; /* 修改为center，移除底部对齐 */

    .search-item {
      flex: 1;
      min-width: 200px;
      /* 移除了 search-text 相关样式 */
    }

    .search-buttons {
      display: flex;
      gap: 8px;
      flex-shrink: 0;
      /* 移除了底部padding，解决对齐问题 */
    }
  }
}

/* 数据容器样式 */
.data-container {
  width: 100%;

  /* PC端表格样式 */
  .pc-table {
    ::v-deep {
      .el-table {
        --el-table-header-text-color: #4e5969;
        --el-table-row-hover-bg-color: #f8f9fa;
      }

      .el-table th {
        background: #f8f9fa;
        font-weight: 600;
      }

      /* 汇总行样式 */
      .el-table__footer-wrapper .el-table-cell {
        font-weight: bold;
        background-color: #e9ecef;
        color: #166ea5;
      }

      .total-count {
        font-weight: 600;
        color: #166ea5;
      }

      .branch-name {
        font-weight: 500;
      }
    }
  }

  /* 手机端卡片样式 */
  .mobile-cards {
    display: none;
    flex-direction: column;
    gap: 16px;

    /* 分校卡片 */
    .branch-card {
      background: #f8f9fa;
      border-radius: 8px;
      padding: 16px;
      border: 1px solid #e9ecef;

      .card-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 12px;
        padding-bottom: 8px;
        border-bottom: 1px solid #dee2e6;

        .branch-title {
          font-size: 16px;
          font-weight: 600;
          color: #1f2937;
        }

        .branch-total {
          font-size: 14px;
          color: #166ea5;
          .total-num {
            font-weight: 600;
          }
        }
      }

      .grade-grid {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        gap: 8px;

        .grade-item {
          background: #fff;
          border-radius: 4px;
          padding: 8px;
          text-align: center;

          .grade-label {
            font-size: 12px;
            color: #6c757d;
            margin-bottom: 4px;
          }

          .grade-value {
            font-size: 16px;
            font-weight: 600;
            color: #1f2937;
          }
        }
      }
    }

    /* 总计卡片 */
    .total-card {
      background: linear-gradient(135deg, #e8f4f8 0%, #f0f8fb 100%);
      border-radius: 8px;
      padding: 16px;
      border: 1px solid #166ea5;

      .total-header {
        font-size: 16px;
        font-weight: 600;
        color: #166ea5;
        margin-bottom: 12px;
        text-align: center;
      }

      .total-grid {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        gap: 8px;

        .total-grade-item {
          background: #fff;
          border-radius: 4px;
          padding: 8px;
          text-align: center;

          .grade-label {
            font-size: 12px;
            color: #6c757d;
            margin-bottom: 4px;
          }

          .grade-value {
            font-size: 16px;
            font-weight: 600;
            color: #1f2937;
          }
        }

        .total-all-item {
          grid-column: span 3;
          background: #166ea5;
          border-radius: 4px;
          padding: 8px;
          text-align: center;

          .grade-label {
            font-size: 12px;
            color: #fff;
            margin-bottom: 4px;
          }

          .grade-value {
            font-size: 18px;
            font-weight: 600;
            color: #fff;
          }
        }
      }
    }

    /* 空数据提示 */
    .empty-tip {
      text-align: center;
      padding: 40px 20px;
      color: #999;

      i {
        font-size: 48px;
        margin-bottom: 16px;
        display: block;
        color: #ced4da;
      }

      p {
        font-size: 16px;
        margin: 0;
      }
    }
  }
}

/* 响应式适配 */
@media (max-width: 768px) {
  .page {
    padding: 8px;
  }

  .page-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
    padding-bottom: 12px;
  }

  .layout {
    padding: 16px;
  }

  /* 搜索区适配 */
  .search-card .search-row {
    flex-direction: column;
    align-items: stretch;
    gap: 10px;
  }

  .search-card .search-row .search-buttons {
    justify-content: flex-end;
  }

  /* 隐藏PC表格，显示手机卡片 */
  .data-container .pc-table {
    display: none;
  }

  .data-container .mobile-cards {
    display: flex;
  }
}

/* 适配平板屏幕 */
@media (min-width: 769px) and (max-width: 1024px) {
  .search-card .search-row .search-item {
    min-width: 160px;
  }
}
</style>